import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import getDd from './forPdf';
import jquery from "jquery";
import $ from "jquery";

function showOne(arr, item, elemClass) {
    arr.forEach(item => item.classList.add(elemClass));
    item.classList.remove(elemClass);
}


function calculator() {
    // переменные
    const rooms = document.querySelectorAll('.roomChoice');
    const allSteps = document.querySelectorAll('.step');
    const withPopUp = document.querySelectorAll('.calculator__checkbox_container');
    const total  = document.querySelector('.caunter');
    const calcContainer = document.querySelectorAll(".calculator_container");
    const form = document.querySelector('.calc_form');

    const buttonMenuItems = document.querySelectorAll('.calc__button_menu_item');
    let kitchen, room, hall, bathroom, electric, plumbing;
    let name, 
    // email, 
    tel;
    // console.log(withPopUp);

    // Kitchen
 
    let floorAreaKitchen = 1, 
        floorBlackKitchen = 0, 
        floorWhiteKitchen = 0, 
        floorFlooringKitchen = 0, 
        floorFlooringSelectedKitchen ='';

    let walsHeightKitchen = 1, 
        walsPerimetrKitchen = 1,   
        walsAreaKitchen = 0, 
        walsBlackKitchen = 0, 
        walsBlackKitchenSelected = '', 
        walsWhiteKitchen = 0, 
        walsWhiteKitchenSelected = '',  
        walsFinishingKitchen = 0,
        walsFinishingKitchenSelected = '' ;

    let ceilingAreaKitchen = 1, 
        ceillingBlackKitchen = 0, 
        ceillingBlackKitchenSelected = '', 
        ceillingWhiteKitchen = 0, 
        ceillingWhiteKitchenSelected = '', 
        ceillinPaintingKitchen = 0;

    let kitchenTotal = 0;

    // Rooms
 
    let numberOfRooms = 1,
        floorAreaRoomsAll = 1, 
        floorBlackRooms = 0, 
        floorWhiteRooms = 0, 
        floorFlooringRooms = 0, 
        floorFlooringSelectedRooms ='';

    let walsHeightRooms = 1, 
        walsPerimetrRoomsAll = 1,   
        walsAreaRooms = 0, 
        walsBlackRooms = 0, 
        walsBlackRoomsSelected = '', 
        walsWhiteRooms = 0, 
        walsWhiteRoomsSelected = '',  
        walsFinishingRooms = 0,
        walsFinishingRoomsSelected = '' ;

    let ceilingAreaRoomsAll = 1, 
        ceillingBlackRooms = 0, 
        ceillingBlackRoomsSelected = '', 
        ceillingWhiteRooms = 0, 
        ceillingWhiteRoomsSelected = '', 
        ceillinPaintingRooms = 0;

    let roomsTotal = 0;

    // Hall
 
    let floorAreaHall = 1, 
        floorBlackHall = 0, 
        floorWhiteHall = 0, 
        floorFlooringHall = 0, 
        floorFlooringSelectedHall ='';

    let walsHeightHall = 1, 
        walsPerimetrHall = 1,   
        walsAreaHall = 0, 
        walsBlackHall = 0, 
        walsBlackHallSelected = '', 
        walsWhiteHall = 0, 
        walsWhiteHallSelected = '',  
        walsFinishingHall = 0,
        walsFinishingHallSelected = '' ;

    let ceilingAreaHall = 1, 
        ceillingBlackHall = 0, 
        ceillingBlackHallSelected = '', 
        ceillingWhiteHall = 0, 
        ceillingWhiteHallSelected = '', 
        ceillinPaintingHall = 0;

    let hallTotal = 0;

    // Bathroom
 
    let floorAreaBath = 1, 
        floorBlackBath = 0, 
        floorWhiteBath = 0, 
        floorFlooringBath = 0;

    let walsHeightBath = 1, 
        walsPerimetrBath = 1,   
        walsAreaBath = 0, 
        walsBlackBath = 0, 
        walsFinishingBath = 0;

    let ceilingAreaBath = 1,  
        ceillingBath = 0, 
        ceillingBathSelected = ''; 


    let bathTotal = 0;

    // electric

    let electroPanel = 0,
        socketsAndSwitches = 0,
        socketsNumber = 0,
        switchesNumber = 0,
        lightness = 0,
        chandlierNumber = 0;

    let electricTotal = 0,
        switchAndSocketTotal = 0;

    // Plumbing
    let tubing = 0,
        tubingPlus = 0,
        bathtub = 0,
        bathtubNum = 0,
        showerCabin = 0,
        showerCabinNum = 0,
        pallet = 0,
        palletNum = 0,
        showerHead = 0,
        showerHeadNum = 0,
        dishwasher = 0,
        dishwasherNumber = 0,
        sink = 0,
        sinkNumber = 0,
        hygienicShower = 0,
        hygienicShowerNumber = 0,
        tap = 0,
        tapNumber = 0,
        toilet = 0,
        toiletNumber = 0,
        dryer = 0,
        dryerNumber = 0,
        washer = 0,
        washerNumber = 0;

    let plumbingTotal = 0;

    const tubingCheckbox = document.querySelector('.tubing_yes');

    tubingCheckbox.addEventListener('change', () => {
        if(tubingCheckbox.checked === true) {
            tubingPlus = 3000;
        }  else {
            tubingPlus = 0;
        }
            calcTotal();
        
    });

    function getPlusTubing(elem1, elem2) {
        let plusTubing = 0;
        if (elem1 === 0 || elem2 === 0) {
            plusTubing = 0;
        } else {
            plusTubing = 3000;
        }

        return plusTubing;
    }

    // глобальные функции

    
    function calcTotal() {
        // Kitchen
        let floorResultKitchen = Math.round((floorBlackKitchen * floorAreaKitchen) + (floorWhiteKitchen * floorAreaKitchen) + (floorFlooringKitchen * floorAreaKitchen));
        walsAreaKitchen = Math.round(walsHeightKitchen * walsPerimetrKitchen);
        let walsResultKitchen = Math.round((walsBlackKitchen * walsAreaKitchen) + (walsWhiteKitchen * walsAreaKitchen) + (walsFinishingKitchen*walsAreaKitchen));
        let ceilingResultKitchen = Math.round((ceillingBlackKitchen * ceilingAreaKitchen) + (ceillingWhiteKitchen * ceilingAreaKitchen) + (ceillinPaintingKitchen * ceilingAreaKitchen));

        // Rooms
        let floorResultRooms = Math.round((floorBlackRooms * floorAreaRoomsAll) + (floorWhiteRooms * floorAreaRoomsAll) + (floorFlooringRooms * floorAreaRoomsAll));
        walsAreaRooms = Math.round(walsHeightRooms * walsPerimetrRoomsAll);
        let walsResultRooms = Math.round((walsBlackRooms * walsAreaRooms) + (walsWhiteRooms *  walsAreaRooms) + (walsFinishingRooms * walsAreaRooms));
        let ceilingResultRooms = Math.round((ceillingBlackRooms*ceilingAreaRoomsAll) + (ceillingWhiteRooms * ceilingAreaRoomsAll) + (ceillinPaintingRooms* ceilingAreaRoomsAll));

        // hall
        let floorResultHall = Math.round((floorBlackHall * floorAreaHall) + (floorWhiteHall * floorAreaHall) + (floorFlooringHall * floorAreaHall));
        walsAreaHall = Math.round(walsHeightHall * walsPerimetrHall);
        let walsResultHall = Math.round((walsBlackHall * walsAreaHall) + (walsWhiteHall * walsAreaHall) + (walsFinishingHall * walsAreaHall));
        let ceilingResultHall = Math.round((ceillingBlackHall * ceilingAreaHall) + (ceillingWhiteHall * ceilingAreaHall) + (ceillinPaintingHall * ceilingAreaHall));


        // bathroom
        let floorResultBath = Math.round((floorBlackBath * floorAreaBath) + (floorWhiteBath * floorAreaBath) + (floorFlooringBath * floorAreaBath)); 
        walsAreaBath = Math.round(walsHeightBath * walsPerimetrBath);
        let walsResultBath = Math.round((walsBlackBath * walsAreaBath) + (walsFinishingBath * walsAreaBath));
        let ceilingResultBath = Math.round((ceillingBath * ceilingAreaBath));

        // electric
        switchAndSocketTotal = socketsNumber + switchesNumber;

        // plumber
        let bathtubTotal = bathtub + getPlusTubing(bathtub, tubingPlus),
            showerCabinTotal = showerCabin + getPlusTubing(showerCabin, tubingPlus),
            dishwasherTotal = dishwasher + getPlusTubing(dishwasher, tubingPlus),
            palletTotal = pallet + getPlusTubing(pallet, tubingPlus),
            showerHeadTotal = showerHead + getPlusTubing(showerHead, tubingPlus),
            sinkTotal = sink + getPlusTubing(sink, tubingPlus),
            hygienicShowerTotal = hygienicShower + getPlusTubing(hygienicShower, tubingPlus),
            tapTotal = tap + getPlusTubing(tap, tubingPlus),
            toiletTotal = toilet + getPlusTubing(toilet, tubingPlus),
            dryerTotal = dryer + getPlusTubing(dryer, tubingPlus),
            washerTotal = washer + getPlusTubing(washer, tubingPlus);
         
        // total
        kitchenTotal = floorResultKitchen + walsResultKitchen + ceilingResultKitchen;
        roomsTotal = floorResultRooms + walsResultRooms + ceilingResultRooms;
        hallTotal = floorResultHall + walsResultHall + ceilingResultHall;
        bathTotal = floorResultBath + walsResultBath + ceilingResultBath;
        electricTotal = Math.round(electroPanel + socketsAndSwitches * switchAndSocketTotal + (lightness * chandlierNumber));
        plumbingTotal = Math.round(tubing + (bathtubTotal * bathtubNum) + (showerCabinTotal * showerCabinNum) + (palletTotal * palletNum) + (showerHeadTotal * showerHeadNum) + (dishwasherTotal * dishwasherNumber) + (sinkTotal * sinkNumber) + (hygienicShowerTotal * hygienicShowerNumber) + (tapTotal * tapNumber) + (toiletTotal * toiletNumber) + (dryerTotal * dryerNumber) + (washerTotal * washerNumber));

        total.textContent = kitchenTotal + roomsTotal + hallTotal + bathTotal + electricTotal + plumbingTotal;
    }
        
    function getStaticInformation(selector) {
        const elements = document.querySelectorAll(selector);

        // console.log(elements);

        elements.forEach((elem)=> {
            elem.addEventListener('click', (e) => {
                switch(elem.getAttribute('name')) {
                    // kitchen
                    case 'floorBlackKitchen':
                        elem.checked === true ? floorBlackKitchen = +elem.value : floorBlackKitchen = 0;
                        break;
                    case 'floorWhiteKitchen':
                        elem.checked === true ? floorWhiteKitchen = +elem.value : floorWhiteKitchen = 0;
                        break;
                    case 'floorFlooringKitchen':
                        elem.checked === true ? floorFlooringKitchen = +elem.value : floorFlooringKitchen = 0;
                        break;
                    case 'walsBlackKitchen':
                        elem.checked === true ? walsBlackKitchen = +elem.value : walsBlackKitchen = 0;
                        break;
                    case 'walsWhiteKitchen':
                        elem.checked === true ? walsWhiteKitchen = +elem.value : walsWhiteKitchen = 0;
                        break;
                    case 'walsFinishingKitchen':
                        elem.checked === true ? walsFinishingKitchen = +elem.value : walsFinishingKitchen = 0;
                        break;
                    case 'ceillingBlackKitchen':
                        elem.checked === true ? ceillingBlackKitchen = +elem.value : ceillingBlackKitchen = 0;
                        break;
                    case 'ceillingWhiteKitchen':
                        elem.checked === true ? ceillingWhiteKitchen = +elem.value : ceillingWhiteKitchen = 0;
                        break;
                    case 'ceillinPaintingKitchen':
                        elem.checked === true ? ceillinPaintingKitchen = +elem.value : ceillinPaintingKitchen = 0;
                        break;
                    // rooms
                    case 'floorBlackRooms':
                        elem.checked === true ? floorBlackRooms = +elem.value : floorBlackRooms = 0;
                        break;
                    case 'floorWhiteRooms':
                        elem.checked === true ? floorWhiteRooms = +elem.value : floorWhiteRooms = 0;
                        break;
                    case 'floorFlooringRooms':
                        elem.checked === true ? floorFlooringRooms = +elem.value : floorFlooringRooms = 0;
                        break;
                    case 'walsBlackRooms':
                        elem.checked === true ? walsBlackRooms = +elem.value : walsBlackRooms = 0;
                        break;
                    case 'walsWhiteRooms':
                        elem.checked === true ? walsWhiteRooms = +elem.value : walsWhiteRooms = 0;
                        // console.log(walsWhiteRooms);
                        break;
                    case 'walsFinishingRooms':
                        elem.checked === true ? walsFinishingRooms = +elem.value : walsFinishingRooms = 0;
                        break;
                    case 'ceillingBlackRooms':
                        elem.checked === true ? ceillingBlackRooms = +elem.value : ceillingBlackRooms = 0;
                        break;
                    case 'ceillingWhiteRooms':
                        elem.checked === true ? ceillingWhiteRooms = +elem.value : ceillingWhiteRooms = 0;
                        break;
                    case 'ceillinPaintingRooms':
                        elem.checked === true ? ceillinPaintingRooms = +elem.value : ceillinPaintingRooms = 0;
                        break;
                    // hall
                    case 'floorBlackHall':
                        elem.checked === true ? floorBlackHall = +elem.value : floorBlackHall = 0;
                        break;
                    case 'floorWhiteHall':
                        elem.checked === true ? floorWhiteHall = +elem.value : floorWhiteHall = 0;
                        break;
                    case 'floorFlooringHall':
                        elem.checked === true ? floorFlooringHall = +elem.value : floorFlooringHall = 0;
                        break;
                    case 'walsBlackHall':
                        elem.checked === true ? walsBlackHall = +elem.value : walsBlackHall = 0;
                        // console.log(walsBlackHall);
                        break;
                    case 'walsWhiteHall':
                        elem.checked === true ? walsWhiteHall = +elem.value : walsWhiteHall = 0;
                        // console.log(walsWhiteHall);
                        break;
                    case 'walsFinishingHall':
                        elem.checked === true ? walsFinishingHall = +elem.value : walsFinishingHall = 0;
                        // console.log(walsFinishingHall);
                        break;
                    case 'ceillingBlackHall':
                        elem.checked === true ? ceillingBlackHall = +elem.value : ceillingBlackHall = 0;
                        break;
                    case 'ceillingWhiteHall':
                        elem.checked === true ? ceillingWhiteHall = +elem.value : ceillingWhiteHall = 0;
                        break;
                    case 'ceillinPaintingHall':
                        elem.checked === true ? ceillinPaintingHall = +elem.value : ceillinPaintingHall = 0;
                        break;
                    // Bathroom
                    case 'floorBlackBath':
                        elem.checked === true ? floorBlackBath = +elem.value : floorBlackBath = 0;
                        // console.log(floorBlackBath);
                        break;
                    case 'floorWhiteBath':
                        elem.checked === true ? floorWhiteBath = +elem.value : floorWhiteBath = 0;
                        // console.log(floorWhiteBath);
                        break;
                    case 'floorFlooringBath':
                        elem.checked === true ? floorFlooringBath = +elem.value : floorFlooringBath = 0;
                        // console.log(floorFlooringBath);
                        break;
                    case 'walsBlackBath':
                        elem.checked === true ? walsBlackBath = +elem.value : walsBlackBath = 0;
                        break;
                    case 'walsFinishingBath':
                        elem.checked === true ? walsFinishingBath = +elem.value : walsFinishingBath = 0;
                        break;
                    case 'ceillingBath':
                        elem.checked === true ? ceillingBath = +elem.value : ceillingBath = 0;
                        break;
                    case 'electricalPanel':
                        elem.checked === true ? electroPanel = +elem.value : electroPanel = 0;
                        break;
                    case 'socketsAndSwitches':
                        elem.checked === true ? socketsAndSwitches = +elem.value : socketsAndSwitches = 0;
                        break;
                    case 'lightness':
                        elem.checked === true ? lightness = +elem.value : lightness = 0;
                        break;
                    case 'tubing':
                        elem.checked === true ? tubing = +elem.value : tubing = 0;
                        if(+elem.value === 0) {
                            tubingPlus = 0;
                        }
                        break;
                    case 'bathtub':
                        elem.checked === true ? bathtub = +elem.value : bathtub = 0;
                        break;
                    case 'showerCabin':
                        elem.checked === true ? showerCabin = +elem.value : showerCabin = 0;
                        break;
                    case 'pallet':
                        elem.checked === true ? pallet = +elem.value : pallet = 0;
                        break;
                    case 'showerHead':
                        elem.checked === true ? showerHead = +elem.value : showerHead = 0;
                        break;
                    case 'dishwasher':
                        elem.checked === true ? dishwasher = +elem.value : bathtub = 0;
                        break;
                    case 'sink':
                        elem.checked === true ? sink = +elem.value : sink = 0;
                        break;
                    case 'hygienicShower':
                        elem.checked === true ? hygienicShower = +elem.value : hygienicShower = 0;
                        break;
                    case 'tap':
                        elem.checked === true ? tap = +elem.value : tap = 0;
                        break;     
                    case 'toilet':
                        elem.checked === true ? toilet = +elem.value : toilet = 0;
                        break;
                    case 'dryer':
                        elem.checked === true ? dryer = +elem.value : dryer = 0;
                        break;
                    case 'washer':
                        elem.checked === true ? washer = +elem.value : washer = 0;
                        break; 
                } 
                   
                calcTotal();
            });
        })
    }

    function getDinamicInformation(selector) {
        const inputs = document.querySelectorAll(selector);

        inputs.forEach((input) => {
            input.addEventListener('change', () => {

                switch(input.getAttribute('name')) {
                    case 'name':
                        name = input.value;
                        break;
                    // case 'email':
                    //     email = input.value;
                    //     break;
                    case 'tel':
                        tel = input.value;
                        break;
                    // kitchen
                    case 'floorAreaKitchen':
                        floorAreaKitchen = +input.value;
                        break;
                    case 'walsPerimetrKitchen':
                        walsPerimetrKitchen= +input.value;
                        break;
                    case 'walsHeightKitchen':
                        walsHeightKitchen = +input.value;
                        break;
                    case 'ceilingAreaKitchen':
                        ceilingAreaKitchen = +input.value;
                        break;
                    // rooms
                    case 'roomQuantity':
                        numberOfRooms = input.value;
                        break;
                    case 'roomsAllFloorArea':
                        floorAreaRoomsAll = +input.value;
                        break;
                    case 'roomsAllPerimetr':
                        walsPerimetrRoomsAll= +input.value;
                        break;
                    case 'roomsAllHeightWalls':
                        walsHeightRooms = +input.value;
                        break;
                    case 'allCealingAreaRooms':
                        ceilingAreaRoomsAll = +input.value;
                        break;
                    // hall
                    case 'floorAreaHall':
                        floorAreaHall = +input.value;
                        break;
                    case 'walsPerimetrHall':
                        walsPerimetrHall= +input.value;
                        break;
                    case 'walsHeightHall':
                        walsHeightHall = +input.value;
                        break;
                    case 'ceilingAreaHall':
                        ceilingAreaHall = +input.value;
                        break;
                    // bathroom
                    case 'floorAreaBath':
                        floorAreaBath = +input.value;
                        // console.log(floorAreaBath);
                        break;
                    case 'walsPerimetrBath':
                        walsPerimetrBath= +input.value;
                        break;
                    case 'walsHeightBath':
                        walsHeightBath = +input.value;
                        // console.log(walsHeightBath);
                        break;
                    case 'ceilingAreaBath':
                        ceilingAreaBath = +input.value;
                        break;
                    case 'socketsNumber':
                        socketsNumber= +input.value;
                        break;
                    case 'switchesNumber':
                        switchesNumber = +input.value;
                        break;
                    case 'chandelierNumber':
                        chandlierNumber = +input.value;
                        break;
                    // plumbing
                    case 'bathtubNumber':
                        bathtubNum = +input.value;
                        break;
                    case 'showerCabinNumber':
                        showerCabinNum= +input.value;
                        break;
                    case 'palletNumber':
                        palletNum = +input.value;
                        break;
                    case 'showerHeadNumber':
                        showerHeadNum = +input.value;
                        break;
                    case 'dishwasherNumber':
                        dishwasherNumber = +input.value;
                        break;
                    case 'sinkNumber':
                        sinkNumber = +input.value;
                        break;
                    case 'hygienicShowerNumber':
                        hygienicShowerNumber = +input.value;
                        break;
                    case 'tapNumber':
                        tapNumber = +input.value;
                        break;
                    case 'toiletNumber':
                        toiletNumber = +input.value;
                        break;
                    case 'dryerNumber':
                        dryerNumber = +input.value;
                        break;
                    case 'washerNumber':
                        washerNumber = +input.value;
                        break;
                }   
                calcTotal();        
            
            });
        })
    
       
    }

    function getSelect(checkBox, selected) {

        selected.addEventListener('change', () => {

            // console.log(floorFlooringSelected);
            switch(selected.getAttribute('name')) {
                // Floor kitchen
                case 'floorFlooringKitchen':
                    checkBox.checked === true ? floorFlooringKitchen = +selected.value : floorFlooringKitchen = 0;
                    checkBox.checked === true ? floorFlooringSelectedKitchen = selected.options[selected.selectedIndex].text : floorFlooringSelectedKitchen = '';
                    break;
                // wals kitchen
                case 'walsBlackKitchen':
                    checkBox.checked === true ? walsBlackKitchen = +selected.value : walsBlackKitchen = 0;
                    checkBox.checked === true ?  walsBlackKitchenSelected = selected.options[selected.selectedIndex].text :  walsBlackKitchenSelected = '';
                    break;
                case 'walsWhiteKitchen':
                    checkBox.checked === true ? walsWhiteKitchen = +selected.value : walsWhiteKitchen = 0;
                    checkBox.checked === true ? walsWhiteKitchenSelected = selected.options[selected.selectedIndex].text : walsWhiteKitchenSelected = '';
                    break;
                case 'walsFinishingKitchen':
                    checkBox.checked === true ? walsFinishingKitchen = +selected.value : walsFinishingKitchen = 0;
                    checkBox.checked === true ? walsFinishingKitchenSelected = selected.options[selected.selectedIndex].text : walsFinishingKitchenSelected = '';
                    break;
                // ceilling kitchen
                case 'ceillingBlackKitchen':
                    checkBox.checked === true ? ceillingBlackKitchen = +selected.value : ceillingBlackKitchen = 0;
                    checkBox.checked === true ? ceillingBlackKitchenSelected = selected.options[selected.selectedIndex].text : ceillingBlackKitchenSelected = '';
                    break;
                case 'ceillingWhiteKitchen':
                    checkBox.checked === true ? ceillingWhiteKitchen = +selected.value : ceillingWhiteKitchen = 0;
                    checkBox.checked === true ? ceillingWhiteKitchenSelected = selected.options[selected.selectedIndex].text : ceillingWhiteKitchenSelected = '';
                    break;
                // Floor rooms
                case 'floorFlooringRooms':
                    checkBox.checked === true ? floorFlooringRooms = +selected.value : floorFlooringRooms = 0;
                    checkBox.checked === true ? floorFlooringSelectedRooms = selected.options[selected.selectedIndex].text : floorFlooringSelectedRooms = '';
                    break;
                // wals rooms
                case 'walsBlackRooms':
                    checkBox.checked === true ? walsBlackRooms = +selected.value : walsBlackRooms = 0;
                    checkBox.checked === true ?  walsBlackRoomsSelected = selected.options[selected.selectedIndex].text :  walsBlackRoomsSelected = '';
                    break;
                case 'walsWhiteRooms':
                    checkBox.checked === true ? walsWhiteRooms = +selected.value : walsWhiteRooms = 0;
                    checkBox.checked === true ? walsWhiteRoomsSelected = selected.options[selected.selectedIndex].text : walsWhiteRoomsSelected = '';
                    break;
                case 'walsFinishingRooms':
                    checkBox.checked === true ? walsFinishingRooms = +selected.value : walsFinishingRooms = 0;
                    checkBox.checked === true ? walsFinishingRoomsSelected = selected.options[selected.selectedIndex].text : walsFinishingRoomsSelected = '';
                    break;
                // ceilling rooms
                case 'ceillingBlackRooms':
                    checkBox.checked === true ? ceillingBlackRooms = +selected.value : ceillingBlackRooms = 0;
                    checkBox.checked === true ? ceillingBlackRoomsSelected = selected.options[selected.selectedIndex].text : ceillingBlackRoomsSelected = '';
                    break;
                case 'ceillingWhiteRooms':
                    checkBox.checked === true ? ceillingWhiteRooms = +selected.value : ceillingWhiteRooms = 0;
                    checkBox.checked === true ? ceillingWhiteRoomsSelected = selected.options[selected.selectedIndex].text : ceillingWhiteRoomsSelected = '';
                    break;
                // Floor hall
                case 'floorFlooringHall':
                    checkBox.checked === true ? floorFlooringHall = +selected.value : floorFlooringHall = 0;
                    checkBox.checked === true ? floorFlooringSelectedHall = selected.options[selected.selectedIndex].text : floorFlooringSelectedHall = '';
                    break;
                // wals hall
                case 'walsBlackHall':
                    checkBox.checked === true ? walsBlackHall = +selected.value : walsBlackHall = 0;
                    checkBox.checked === true ?  walsBlackHallSelected = selected.options[selected.selectedIndex].text :  walsBlackHallSelected = '';

                    break;
                case 'walsWhiteHall':
                    checkBox.checked === true ? walsWhiteHall = +selected.value : walsWhiteHall = 0;
                    checkBox.checked === true ? walsWhiteHallSelected = selected.options[selected.selectedIndex].text : walsWhiteHallSelected = '';
                    break;
                case 'walsFinishingHall':
                    checkBox.checked === true ? walsFinishingHall = +selected.value : walsFinishingHall = 0;
                    checkBox.checked === true ?  walsFinishingHallSelected = selected.options[selected.selectedIndex].text :  walsFinishingHallSelected = '';

                    break;
                // ceilling hall
                case 'ceillingBlackHall':
                    checkBox.checked === true ? ceillingBlackHall = +selected.value : ceillingBlackHall = 0;
                    checkBox.checked === true ? ceillingBlackHallSelected = selected.options[selected.selectedIndex].text : ceillingBlackHallSelected = '';
                    break;
                case 'ceillingWhiteHall':
                    checkBox.checked === true ? ceillingWhiteHall = +selected.value : ceillingWhiteHall = 0;
                    checkBox.checked === true ? ceillingWhiteHallSelected = selected.options[selected.selectedIndex].text : ceillingWhiteHallSelected = '';
                    break;
                case 'ceillingBath':
                    checkBox.checked === true ? ceillingBath = +selected.value : ceillingBath = 0;
                    checkBox.checked === true ? ceillingBathSelected = selected.options[selected.selectedIndex].text : ceillingBathSelected = '';
        
                    break;
            }   
            calcTotal();   
        })
 
    }

    function addClassForOneElement(arr, elem, elemClass) {
        arr.forEach(item => item.classList.remove(elemClass));
        elem.classList.add(elemClass);
    }


    // Submit

    
    try {
        const finalStep = document.querySelector('.final_step');
        let messError = finalStep.querySelector('.mess_err');
        let messSuccess = finalStep.querySelector('.mess_success');

        $(".calc_form").on("submit", function (t) {
            t.preventDefault()
            let dd;
            // alert('work')
            var phone, name, source, term, formname, medium, campaign, content
            name = $(this).find('.name').val()
            phone = $(this).find('.tel').val() 
            source = $(this).find('.source').val() 
            term = $(this).find('.term').val() 
            formname = $(this).find('.formname').val() 
            medium = $(this).find('.medium').val() 
            campaign = $(this).find('.campaign').val() 
            content = $(this).find('.content').val() 
            $.ajax({
                url: "mail.php",
                method: "POST",
                data: {
                    name: name,
                    phone: phone,
                    source: source,
                    term: term,
                    formname: formname,
                    medium: medium,
                    campaign: campaign,
                    content : content 
      
                },
                success: function (t) {
                    // window.dataLayer = window.dataLayer || [];
                    // dataLayer.push ({
                    // 'event': 'formSuccess',
                    // 'formName': formname,
                    // });
                    messSuccess.textContent = 'Спасибо, мы получили вашу заявку. Свяжемся с вами в рабочее время';
                    messError.textContent = '';
            
                    form.reset();
                },
                error: function (t) {
                    messSuccess.textContent = ' ';
                    messError.textContent = 'Извините, что-то пошло не так. Попробуйте снова.';
                }
            });

            try {
                dd = getDd({
                    nameLet: name,
                   //  emailLet: email,
                    telLet: tel,
                    kitchenLet: kitchen, 
                    roomLet: room, 
                    hallLet: hall, 
                    electricaLet: electric, 
                    plumbingLet: plumbing, 
                    bathroomLet: bathroom,
                    totalKitchen: kitchenTotal,
                   // floor Kitchen
                   floorWhiteLetKitchen: floorWhiteKitchen, 
                   floorBlackLetKitchen: floorBlackKitchen, 
                   flooringLetKitchen: floorFlooringKitchen, 
                   floorinfSelectedKitchen: floorFlooringSelectedKitchen, 
                   floorSquereKitchen: floorAreaKitchen,
                   // wals Kitchen
                   walsWhiteLetKitchen: walsWhiteKitchen, 
                   walsWhiteSelectedKitchen: walsWhiteKitchenSelected, 
                   walsBlackLetKitchen: walsBlackKitchen, 
                   walsBlackSelectedKitchen: walsBlackKitchenSelected, 
                   walsFinishingletKitchen: walsFinishingKitchen,
                   walsFinishingSelectedKitchen: walsFinishingKitchenSelected,
                   walsSquereKitchen: walsAreaKitchen,
                   // ceiling kitchen
                   ceilingWhiteLetKitchen: ceillingWhiteKitchen, 
                   ceilingWhiteSelectedKitchen: ceillingWhiteKitchenSelected, 
                   ceilingBlackLetKitchen: ceillingBlackKitchen, 
                   ceilingBlackSelectedKitchen: ceillingBlackKitchenSelected,  
                   ceilingPaintingLetKitchen: ceillinPaintingKitchen,  
                   ceilingSquereKitchen: ceilingAreaKitchen,
                   
                   // rooms
                   numberRooms: numberOfRooms,
                   totalRooms: roomsTotal, 
    
                   // floor rooms
                   floorWhiteLetRooms: floorWhiteRooms, 
                   floorBlackLetRooms: floorBlackRooms, 
                   flooringLetRooms: floorFlooringRooms, 
                   floorinfSelectedRooms: floorFlooringSelectedRooms, 
                   allFloorSquereRooms: floorAreaRoomsAll, 
                   // wals rooms
                   walsWhiteLetRooms: walsWhiteRooms, 
                   walsWhiteSelectedRooms: walsWhiteRoomsSelected, 
                   walsBlackLetRooms: walsBlackRooms, 
                   walsBlackSelectedRooms: walsBlackRoomsSelected, 
                   walsFinishingletRooms: walsFinishingRooms, 
                   walsFinishingSelectedRooms: walsFinishingRoomsSelected, 
                   walsSquereRooms: walsAreaRooms, 
                   // ceiling rooms
                   ceilingWhiteLetRooms: ceillingWhiteRooms, 
                   ceilingWhiteSelectedRooms: ceillingWhiteRoomsSelected, 
                   ceilingBlackLetRooms: ceillingBlackRooms,  
                   ceilingBlackSelectedRooms: ceillingBlackRoomsSelected, 
                   ceilingPaintingLetRooms: ceillinPaintingRooms, 
                   ceilingSquereRooms: ceilingAreaRoomsAll,
    
                   // hall
                   totalHall: hallTotal,
                   // floor hall
                   floorWhiteLetHall: floorWhiteHall,
                   floorBlackLetHall: floorBlackHall,
                   flooringLetHall: floorFlooringHall,
                   floorinfSelectedHall: floorFlooringSelectedHall,
                   floorSquereHall: floorAreaHall, 
                    // wals hall
                   walsWhiteLetHall: walsWhiteHall,
                   walsWhiteSelectedHall: walsWhiteHallSelected,
                   walsBlackLetHall: walsBlackHall,
                   walsBlackSelectedHall: walsBlackHallSelected,
                   walsFinishingletHall: walsFinishingHall,
                   walsFinishingSelectedHall: walsFinishingHallSelected,
                   walsSquereHall: walsAreaHall,
                   // ceiling hall
                   ceilingWhiteLetHall: ceillingWhiteHall,
                   ceilingWhiteSelectedHall: ceillingWhiteHallSelected,
                   ceilingBlackLetHall: ceillingBlackHall,
                   ceilingBlackSelectedHall: ceillingBlackHallSelected,
                   ceilingPaintingLetHall: ceillinPaintingHall,
                   ceilingSquereHall: ceilingAreaHall,
                   // floor Bathroom
                   floorSquereBath: floorAreaBath,
                   floorBlackLetBath: floorBlackBath,
                   floorWhiteLetBath: floorWhiteBath,
                   flooringLetBath: floorFlooringBath,
                   // wals bathroom
                   wallsBlackLetBath: walsBlackBath,
                   wallsFinishingletBath: walsFinishingBath,
                   wallsSquereBath: walsAreaBath,
                   // ceiling Bathrooms
                   cealingLetBath: ceillingBath,
                   ceilingSelectedBath: ceillingBathSelected, 
                   ceilingSquereBath: ceilingAreaBath,
                   totalBath: bathTotal,
                   // electric
                   electricPanel: electroPanel,
                   switchAndSocket: socketsAndSwitches,
                   switchAndSocketNumber: switchAndSocketTotal,
                   lightnessLet: lightness,
                   numberOfChandlier: chandlierNumber,
                   totalElectric: electricTotal,
                   // plumbing
    
                   tubingLet: tubing,
                   tubingPlusLet: tubing,
                   bathtubLet: bathtub,
                   bathtubNumLet: bathtubNum,
                   showerCabinLet: showerCabin,
                   showerCabinNumLet: showerCabinNum,
                   palletLet: pallet,
                   palletNumLet: palletNum,
                   showerHeadLet: showerHead,
                   showerHeadNumLet: showerHeadNum,
                    dishwasherLet: dishwasher,
                   dishwasherNumberLet: dishwasherNumber,
                   sinkLet: sink,
                   sinkNumberLet: sinkNumber,
                   hygienicShowerLet: hygienicShower,
                   hygienicShowerNumberLet: hygienicShowerNumber,
                   tapLet: tap,
                   tapNumberLet: tapNumber,
                   toiletLet: toilet,
                   toiletNumberLet: toiletNumber,
                   dryerLet: dryer,
                   dryerNumberLet: dryerNumber,
                   washerLet: washer,
                   washerNumberLet: washerNumber,
                   plumbingTotalLet: plumbingTotal
    
               });
    
           } catch (e) {
            //    console.log(e);
           }
      
           pdfMake.createPdf(dd).open();


          })


        // $(function() {
        //   document.querySelector('.calc_form').addEventListener('submit', function(evt){
        //     let dd;
        //     try {
        //         dd = getDd({
        //             nameLet: name,
        //            //  emailLet: email,
        //             telLet: tel,
        //             kitchenLet: kitchen, 
        //             roomLet: room, 
        //             hallLet: hall, 
        //             electricaLet: electric, 
        //             plumbingLet: plumbing, 
        //             bathroomLet: bathroom,
        //             totalKitchen: kitchenTotal,
        //            // floor Kitchen
        //            floorWhiteLetKitchen: floorWhiteKitchen, 
        //            floorBlackLetKitchen: floorBlackKitchen, 
        //            flooringLetKitchen: floorFlooringKitchen, 
        //            floorinfSelectedKitchen: floorFlooringSelectedKitchen, 
        //            floorSquereKitchen: floorAreaKitchen,
        //            // wals Kitchen
        //            walsWhiteLetKitchen: walsWhiteKitchen, 
        //            walsWhiteSelectedKitchen: walsWhiteKitchenSelected, 
        //            walsBlackLetKitchen: walsBlackKitchen, 
        //            walsBlackSelectedKitchen: walsBlackKitchenSelected, 
        //            walsFinishingletKitchen: walsFinishingKitchen,
        //            walsFinishingSelectedKitchen: walsFinishingKitchenSelected,
        //            walsSquereKitchen: walsAreaKitchen,
        //            // ceiling kitchen
        //            ceilingWhiteLetKitchen: ceillingWhiteKitchen, 
        //            ceilingWhiteSelectedKitchen: ceillingWhiteKitchenSelected, 
        //            ceilingBlackLetKitchen: ceillingBlackKitchen, 
        //            ceilingBlackSelectedKitchen: ceillingBlackKitchenSelected,  
        //            ceilingPaintingLetKitchen: ceillinPaintingKitchen,  
        //            ceilingSquereKitchen: ceilingAreaKitchen,
                   
        //            // rooms
        //            numberRooms: numberOfRooms,
        //            totalRooms: roomsTotal, 
    
        //            // floor rooms
        //            floorWhiteLetRooms: floorWhiteRooms, 
        //            floorBlackLetRooms: floorBlackRooms, 
        //            flooringLetRooms: floorFlooringRooms, 
        //            floorinfSelectedRooms: floorFlooringSelectedRooms, 
        //            allFloorSquereRooms: floorAreaRoomsAll, 
        //            // wals rooms
        //            walsWhiteLetRooms: walsWhiteRooms, 
        //            walsWhiteSelectedRooms: walsWhiteRoomsSelected, 
        //            walsBlackLetRooms: walsBlackRooms, 
        //            walsBlackSelectedRooms: walsBlackRoomsSelected, 
        //            walsFinishingletRooms: walsFinishingRooms, 
        //            walsFinishingSelectedRooms: walsFinishingRoomsSelected, 
        //            walsSquereRooms: walsAreaRooms, 
        //            // ceiling rooms
        //            ceilingWhiteLetRooms: ceillingWhiteRooms, 
        //            ceilingWhiteSelectedRooms: ceillingWhiteRoomsSelected, 
        //            ceilingBlackLetRooms: ceillingBlackRooms,  
        //            ceilingBlackSelectedRooms: ceillingBlackRoomsSelected, 
        //            ceilingPaintingLetRooms: ceillinPaintingRooms, 
        //            ceilingSquereRooms: ceilingAreaRoomsAll,
    
        //            // hall
        //            totalHall: hallTotal,
        //            // floor hall
        //            floorWhiteLetHall: floorWhiteHall,
        //            floorBlackLetHall: floorBlackHall,
        //            flooringLetHall: floorFlooringHall,
        //            floorinfSelectedHall: floorFlooringSelectedHall,
        //            floorSquereHall: floorAreaHall, 
        //             // wals hall
        //            walsWhiteLetHall: walsWhiteHall,
        //            walsWhiteSelectedHall: walsWhiteHallSelected,
        //            walsBlackLetHall: walsBlackHall,
        //            walsBlackSelectedHall: walsBlackHallSelected,
        //            walsFinishingletHall: walsFinishingHall,
        //            walsFinishingSelectedHall: walsFinishingHallSelected,
        //            walsSquereHall: walsAreaHall,
        //            // ceiling hall
        //            ceilingWhiteLetHall: ceillingWhiteHall,
        //            ceilingWhiteSelectedHall: ceillingWhiteHallSelected,
        //            ceilingBlackLetHall: ceillingBlackHall,
        //            ceilingBlackSelectedHall: ceillingBlackHallSelected,
        //            ceilingPaintingLetHall: ceillinPaintingHall,
        //            ceilingSquereHall: ceilingAreaHall,
        //            // floor Bathroom
        //            floorSquereBath: floorAreaBath,
        //            floorBlackLetBath: floorBlackBath,
        //            floorWhiteLetBath: floorWhiteBath,
        //            flooringLetBath: floorFlooringBath,
        //            // wals bathroom
        //            wallsBlackLetBath: walsBlackBath,
        //            wallsFinishingletBath: walsFinishingBath,
        //            wallsSquereBath: walsAreaBath,
        //            // ceiling Bathrooms
        //            cealingLetBath: ceillingBath,
        //            ceilingSelectedBath: ceillingBathSelected, 
        //            ceilingSquereBath: ceilingAreaBath,
        //            totalBath: bathTotal,
        //            // electric
        //            electricPanel: electroPanel,
        //            switchAndSocket: socketsAndSwitches,
        //            switchAndSocketNumber: switchAndSocketTotal,
        //            lightnessLet: lightness,
        //            numberOfChandlier: chandlierNumber,
        //            totalElectric: electricTotal,
        //            // plumbing
    
        //            tubingLet: tubing,
        //            tubingPlusLet: tubing,
        //            bathtubLet: bathtub,
        //            bathtubNumLet: bathtubNum,
        //            showerCabinLet: showerCabin,
        //            showerCabinNumLet: showerCabinNum,
        //            palletLet: pallet,
        //            palletNumLet: palletNum,
        //            showerHeadLet: showerHead,
        //            showerHeadNumLet: showerHeadNum,
        //             dishwasherLet: dishwasher,
        //            dishwasherNumberLet: dishwasherNumber,
        //            sinkLet: sink,
        //            sinkNumberLet: sinkNumber,
        //            hygienicShowerLet: hygienicShower,
        //            hygienicShowerNumberLet: hygienicShowerNumber,
        //            tapLet: tap,
        //            tapNumberLet: tapNumber,
        //            toiletLet: toilet,
        //            toiletNumberLet: toiletNumber,
        //            dryerLet: dryer,
        //            dryerNumberLet: dryerNumber,
        //            washerLet: washer,
        //            washerNumberLet: washerNumber,
        //            plumbingTotalLet: plumbingTotal
    
        //        });
    
        //    } catch (e) {
        //     //    console.log(e);
        //    }
      
        //    pdfMake.createPdf(dd).open();

        //     var http = new XMLHttpRequest(), f = this;
        //     var th = $(this);
        //     evt.preventDefault();
        //     http.open("POST", "mail.php", true);
        //     http.onreadystatechange = function() {
        //       if (http.readyState == 4 && http.status == 200) {
        //         messSuccess.textContent = 'Спасибо, мы получили вашу заявку. Свяжемся с вами в рабочее время';
        //          messError.textContent = '';
    
        //         form.reset();
        //       }
        //     }
        //     http.onerror = function() {
        //         messSuccess.textContent = ' ';
        //         messError.textContent = 'Извините, что-то пошло не так. Попробуйте снова.';
        //     }
        //     http.send(new FormData(f));

        //   }, false);
         
        // });
      } catch(e) {
        // console.log(e);
    
        // console.log('Ошибка');
      } 

   

    // отмечается только один чекбос
    calcContainer.forEach(element => {
        const checkboxes = element.querySelectorAll('.checkbox');
        const selectBox = element.querySelector('.calculator_select'); 

        checkboxes.forEach(item => {
            const yesCheckbox = item.classList.contains('yes');
            item.addEventListener('click', () => {
                // console.log(item);
                checkboxes.forEach(box => box.checked = false);
                item.checked = true;
                
                getStaticInformation('.checkbox ');
                calcTotal();  
                try {
                    if(!yesCheckbox) {
                        selectBox.classList.add('hide');
                        yesCheckbox.checked = false;
                    } 
                } catch (e) {
                    // console.log(e);
                }
                
            })  
        });
    });

    const nextStep = document.querySelectorAll('.next_step');
    const prevStep = document.querySelectorAll('.prev_step');

    // переключение по шагам

    const stepWithRoom = document.querySelectorAll('.stepWithRoom');

    function addACtiveToBtnBottom(btn) {
        addClassForOneElement(buttonMenuItems, btn, 'calc__button_menu_item--active');
        btn.classList.add('calc__button_menu_item--visited');
    }

    try {
        // const subSteps = step.querySelectorAll('.subStep');
        showOne(allSteps,  allSteps[0], 'hide');


        nextStep.forEach((btn, i) => {
            btn.addEventListener('click', () => {
                showOne(allSteps,  allSteps[i+1], 'hide');
                addACtiveToBtnBottom(buttonMenuItems[i]);
                switch(btn.getAttribute('data-name')) {
                    case 'next_kitchen':
                            kitchen = true; 
                        break;
                    case 'next_room':
                            room = true;
                        break;
                    case 'next_hall':
                            hall = true;
                        break;
                    case 'next_bathroom':
                            bathroom = true;
                        break;
                    case 'next_electric':
                            electric = true;
                        break;
                    case 'next_plumbing':
                           plumbing = true;
                        break;
                }  
            });
        });

        prevStep.forEach((btn, i) => {

            btn.addEventListener('click', () => {
                showOne(allSteps,  allSteps[i], 'hide');
                addACtiveToBtnBottom(buttonMenuItems[i-1]);

                switch(btn.getAttribute('data-name')) {
                    case 'prev_kitchen':
                            kitchen = true; 
                        break;
                    case 'prev_room':
                            room = true;
                        break;
                    case 'prev_hall':
                            hall = true;
                        break;
                    case 'prev_bathroom':
                            bathroom = true;
                        break;
                    case 'prev_electric':
                            electric = true;
                        break;
                    case 'prev_plumbing':
                           plumbing = true;
                        break;
                }  
            });
        });
        
    } catch(e) {
        // console.log(e);
    }  

    const images = document.querySelectorAll('.calc_image ');
    showOne(images,  images[0], 'hide');

    function showImg(btnSelector, shownImg) {
        const imgBtn = document.querySelectorAll(btnSelector);
        imgBtn.forEach((btn) => {
            btn.addEventListener('click', () => {
                showOne(images,  shownImg, 'hide');
            })
        })
    }

    showImg('.floor_img', images[1]);
    showImg('.final_img', images[4]);
    showImg('.usual_img', images[0]);
    showImg('.ceiling_img', images[3]);

   
    stepWithRoom.forEach((step) => {
        try {
            const subSteps = step.querySelectorAll('.subStep');
            const nextSubStep = step.querySelectorAll('.next_substep');
            const prevSubStep = step.querySelectorAll('.prev_substep');
            showOne(subSteps,  subSteps[0], 'hide');

            nextSubStep.forEach((btn, i) => {
                btn.addEventListener('click', () => {
                    showOne(subSteps,  subSteps[i+1], 'hide');
                    
                });
            });
    
            prevSubStep.forEach((btn, i) => {
                btn.addEventListener('click', () => {
                    showOne(subSteps,  subSteps[i], 'hide');

                });
            });
            
        } catch(e) {
            // console.log(e);
        }  

        try {
            const subStepsWithAtributes = step.querySelectorAll('.subStepAtributes');
            const calcMenu = step.querySelectorAll('.calculator_menu__item');
            const substepBtnsNext= step.querySelectorAll('.next_inner_substep');
            const substepBtnsPrev = step.querySelectorAll('.prev_inner_substep');
            calcMenu[0].classList.add('calculator_menu__item--active');
            showOne(subStepsWithAtributes,  subStepsWithAtributes[0], 'hide');

            calcMenu.forEach((point, i) => {
                point.addEventListener('click', () => {
                        showOne(subStepsWithAtributes,  subStepsWithAtributes[i], 'hide');
                        addClassForOneElement(calcMenu, point, 'calculator_menu__item--active');
                        showOne(images,  images[i+1], 'hide');
                })
            });

            substepBtnsNext.forEach((btn, i) => {
                btn.addEventListener('click', () => {
                    showOne(subStepsWithAtributes,  subStepsWithAtributes[i+1], 'hide');
                    addClassForOneElement(calcMenu, calcMenu[i+1], 'calculator_menu__item--active');
                    showOne(images,  images[i+2], 'hide');
                });
            });
    
            substepBtnsPrev.forEach((btn, i) => {
                btn.addEventListener('click', () => {
                    showOne(subStepsWithAtributes,  subStepsWithAtributes[i], 'hide');
                    addClassForOneElement(calcMenu, calcMenu[i], 'calculator_menu__item--active');
                    showOne(images,  images[i+1], 'hide');
                });
            });
            
        } catch(e) {
            // console.log(e);
        }  
 
});

    showOne(allSteps,  allSteps[0], 'hide');
    
    function swowRoomAtributes(btn, elementId) {
        const elem = document.getElementById(elementId);
        btn.addEventListener('click', () => { 
            showOne(allSteps,  elem, 'hide');
        });
        
    }

    // показать нужную комнату

        rooms.forEach((roomItem) => {
            roomItem.addEventListener('change', () => {
                switch(roomItem.getAttribute('name')) {
                    case 'kitchen':
                        if(roomItem.checked) {
                            swowRoomAtributes(nextStep[0], 'kitchen');
                            addACtiveToBtnBottom(buttonMenuItems[0]);
                            kitchen = true; 
                        } 
                        break;
                    case 'rooms':
                        if(roomItem.checked) {
                            swowRoomAtributes(nextStep[0], "rooms");
                            addACtiveToBtnBottom(buttonMenuItems[1]);
                            showOne(images,  images[0], 'hide');
                            room = true;
                        } 
                        break;
                    case 'hall':
                        if(roomItem.checked) {
                            swowRoomAtributes(nextStep[0], "hall");
                            addACtiveToBtnBottom(buttonMenuItems[2]);
                            hall = true;
                        } 
                        break;
                    case 'bathroom':
                        if(roomItem.checked) {
                            swowRoomAtributes(nextStep[0], "bathroom");
                            addACtiveToBtnBottom(buttonMenuItems[3]); 
                            bathroom = true;
                        } 
                        break;
                    case 'electric':
                        if(roomItem.checked) {
                            swowRoomAtributes(nextStep[0], "electric");  
                            addACtiveToBtnBottom(buttonMenuItems[4]); 
                            showOne(images,  images[0], 'hide');
                
                            electric = true;
                        } 
                        break;
                    case 'plumbing':
                        if(roomItem.checked) {
                            swowRoomAtributes(nextStep[0], "plumbing");
                            addACtiveToBtnBottom(buttonMenuItems[5]);
                            showOne(images,  images[0], 'hide');

                            plumbing = true;
                        } 
                        break;
                }  
            }) 
        })

    // нижнее меню
        buttonMenuItems.forEach((btnItem) => {
            btnItem.addEventListener('click', () => {
                addACtiveToBtnBottom(btnItem);
                switch(btnItem.getAttribute('data-name')) {
                    case 'kitchen':
                        showOne(allSteps,  allSteps[1], 'hide');
                        showOne(images,  images[1], 'hide');
                        kitchen = true; 
                        break;
                    case 'rooms':
                        showOne(allSteps,  allSteps[2], 'hide');
                        showOne(images,  images[0], 'hide');
                        room = true;
                        break;
                    case 'hall':
                        showOne(allSteps,  allSteps[3], 'hide');
                        showOne(images,  images[1], 'hide');
                        hall = true;
                        break;
                    case 'bathroom':
                        showOne(allSteps,  allSteps[4], 'hide');
                        showOne(images,  images[1], 'hide');
                        bathroom = true;
                        break;
                    case 'electric':
                        showOne(allSteps,  allSteps[5], 'hide');
                        showOne(images,  images[0], 'hide');
                        electric = true;
                        break;
                    case 'plumbing':
                        showOne(allSteps,  allSteps[6], 'hide');
                        showOne(images,  images[0], 'hide');
                        plumbing = true;
                        break;
                     case 'final':
                        showOne(allSteps,  allSteps[7], 'hide');
                        showOne(images,  images[4], 'hide');

                        break;
                }  
            }) 
        })


        // вызов глобальных функций

        getDinamicInformation('.area_input');

        getStaticInformation('.checkbox ');


        try {
            withPopUp.forEach((item) => {
                const yesCheckbox = item.querySelector('.yes');
                const selectBox = item.querySelector('.calculator_select'); 
    
                yesCheckbox.addEventListener('change', () => {
                    getSelect(yesCheckbox, selectBox);
                    if(yesCheckbox.checked === true) {
                        selectBox.classList.remove('hide'); 
                        getSelect(yesCheckbox, selectBox);
                    } else {
                        selectBox.classList.add('hide');     
                    }
    
                    calcTotal();
                });  
            });
    
        } catch(e) {
            // console.log(e)
        }
}


export default calculator;
export {showOne};